export const GET_EXAM_BOARDS = "GET_EXAM_BOARDS"
export const GET_EXAM_BOARDS_SUCCESS = "GET_EXAM_BOARDS_SUCCESS"
export const GET_EXAM_BOARDS_FAILED = "GET_EXAM_BOARDS_FAILED"